import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ReferenceDocument } from 'src/app/model/referenceDocument';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ArrayUtils } from 'src/app/utils/arrayUtils';
import { Procedure } from '../../../model/procedure';
import { ProcedureService } from '../../../services/procedure.service';
import { MatSelectChange } from '@angular/material/select';

export interface DialogDataRefDoc {
  refDoc: ReferenceDocument;
  isEdit: boolean;
  disabled: boolean;
  idApp: number;
}

@Component({
    selector: 'app-edit-reference-docs',
    templateUrl: './edit-reference-docs.component.html',
    standalone: false,
})
export class EditReferenceDocsComponent implements OnInit {

  procedures: Procedure[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataRefDoc,
    public dialogRef: MatDialogRef<EditReferenceDocsComponent>,
    private translate: TranslateService,
    private procedureService: ProcedureService,
    public snackBarService: SnackBarService,
    private themeService: ThemeService) { }

  ngOnInit(): void {
    this.procedureService.getProceduresByIdApplication(this.data.idApp).pipe(takeUntil(this.destroy$)).subscribe((data: Procedure[]) => this.procedures = data);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOkClick(): void {
    const errors = [];

    const item = this.data.refDoc;

    if (item.code == null) {
      errors.push(this.translate.instant('protocolEdit.referenceDocs.form.error.code'));
    }

    if (ArrayUtils.isEmpty(errors)) {
      this.dialogRef.close(item);
    } else {
      const error = errors.join('\n');
      this.snackBarService.sendError(error);
      console.error(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }

  onSelectProcedure(event: number | MatSelectChange): void {
    let idProcedure: number;

    if (typeof event === 'number') {
      idProcedure = event;
    } else {
      idProcedure = +event.source.value;
    }

    const procedure =  this.procedures.find(pf => pf.id === idProcedure);
    this.data.refDoc.code = procedure.name;
    this.data.refDoc.name = procedure.description;
  }
}
